module.exports = __webpack_public_path__ + "media/bootstrap-icons/record-btn-bd62ee0a.svg";